import React from "react";
import LandingPageLayout from "../../shared/Layouts/LandingPageLayout";
import { ADMIN_PLACEHOLDER, BACKGROUND_BEHIND } from "../../assets";

function Admin() {
  return (
    <LandingPageLayout
      title={<>Admin and Management</>}
      currentLink="Structure of the court"
    >
      <div className="flex items-center justify-center flex-col py-8 sm:py-10 px-4 sm:px-8 lg:px-32">
        <div className="w-full gap-6 sm:gap-8 lg:gap-10 mt-8 sm:mt-10">
          {[1].map((_, index) => (
            <div
              key={index}
              className="w-full sm:w-[60%] lg:w-[30%] flex flex-col relative items-center justify-center gap-y-3"
            >
              <div className="bg-[#F5F5F5] p-3 sm:p-4 lg:p-5 rounded-lg w-full flex items-center justify-center">
                <img
                  src={ADMIN_PLACEHOLDER}
                  className="w-full min-h-[280px] sm:min-h-[320px] lg:min-h-[360px] object-cover h-full z-30 rounded-md"
                  alt="Dr. U.C. Onyia"
                />
              </div>
              <img
                src={BACKGROUND_BEHIND}
                className="absolute w-full object-cover h-[200px] sm:h-[240px] lg:h-[271px] z-10 bottom-[2rem] sm:bottom-[2.5rem] lg:bottom-[3rem]"
                alt=""
              />

              <div className="flex flex-col justify-center gap-y-2 sm:gap-y-3 items-center mt-3 px-4 text-center">
                <span className="text-globalGreen text-sm sm:text-[16px] font-semibold">
                  Dr. U.C. Onyia
                </span>
                {/* <span className="text-xs sm:text-sm font-medium text-gray-regular text-center leading-relaxed">
                  {item.role}
                </span> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </LandingPageLayout>
  );
}

export default Admin;
